// user details and actions details
export const USER_DETAILS = {
  LOAD: "USER_DETAILS_LOAD",
  SUCCESS: "USER_DETAILS_LOAD_SUCCESS",
  FAIL: "USER_DETAILS_LOAD_FAIL",
  RESET: "USER_DETAILS_LOAD_RESET",
  CLICKED_AMAZING: "USER_DETAILS_CLICKED_AMAZING_HIDE",
  SET_DO_NOT_SHOW_ASSET_BROWSER_POPUP: "USER_DETAILS_SET_DO_NOT_SHOW_ASSET_BROWSER_POPUP",
  SHOW_TOOL_TIP_FIRST_TIME: "USER_DETAILS_SHOW_TOOL_TIP_FIRST_TIME",
  HIDE_TOOL_TIP_FIRST_TIME: "USER_DETAILS_HIDE_TOOL_TIP_FIRST_TIME",
  SET_PLAN_TYPE: "USER_DETAILS_SET_PLAN_TYPE",
};
